module.exports = __webpack_public_path__ + "8d37b1a76ba8fa77690bbce3351c720d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/makeup-pink-s.png
// module id = 2463
// module chunks = 0